<template>
  <form id="id-new-convo-form">
    <p v-if="errors.length" class="text-danger">
      <b>Please correct the following error(s):</b>
      <ul>
        <li :key="error" v-for="error in errors">{{ error }}</li>
      </ul>
    </p>
    <div class="form-group">
      <label for="id-password" style="float: left;">New password</label>
      <input
        id="id-password"
        v-model="password"
        type="password"
        placeholder="Enter new password"
        class="form-control" 
        required
      >
      <br />
      <label for="id-password" style="float: left;">Password Confirmation</label>
      <input
        id="id-password-confirm"
        v-model="password2"
        type="password"
        placeholder="Confirm password"
        class="form-control" 
        required
      >
    </div>
    <div class="modal-footer bg-light stretch-footer text-right">
      <b-button
        pill
        variant="success"
        @click="updatePassword()"
      >
        <b-spinner v-if="savePending === true" small></b-spinner>
        <span v-else>Save</span>
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "../../events/eventBus";

export default {
  name: "ChangePassword",
  data() {
    return {
      password: null,
      password2: null,
      errors: [],
      savePending: false
    };
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"])
  },
  methods: {
    async updatePassword() {
      if (this.password !== this.password2) {
        this.errors.push("Passwords do not match");
      } else {
        try {
          this.savePending = true;
          const payload = {
            "fname": this.currentUser.fname,
            "lname": this.currentUser.lname,
            "email": this.currentUser.email,
            "password": this.password,
          };
          await this.$ConveyApi.usersApi.updateCurrentUser({ payload });
          this.$toastr("success", "Password successfully updated.");
          EventBus.$emit("close-modal");
        } 
        catch (err) {
          this.errorMsg = err.response.data.data.error;
          this.errors.push(this.errorMsg.split(": ")[1]);        
        } finally {
          this.savePending = false;
        }
      }
    }
  }
};
</script>

<style>
.stretch-footer {
  margin-left:-16px;
  margin-right:-16px;
  margin-bottom:-16px;
}
</style>